<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Frescobaldi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Non si può fare a meno di innamorarsi della Toscana. Facile per gli occhi; pensare in grande, dolci colline e
                        villaggi dai tetti di terracotta, e facili sul giaciglio; pensa a vini bei frizzanti e sostanziosi,
                        zuppe fatte in casa. Anni di storia hanno scolpito la forma del paesaggio in quello che è oggi e l'enologo Frescobaldi è uno degli artisti che possiamo ringraziare per questo.
                    </div>

                    <div class="howto-title2">Sette secoli</div>
                    <div class="howto-text">
                        La più antica tenuta (o meglio le tenute, visto che ne ha sei) in Toscana, sono le proprietà dei Frescolbaldi
                        ovunque nella regione. Il loro primo, Castello di Nipozzano nel cuore del Chianti Rufina,
                        risale a 700 anni e un tempo era servito ad artisti rinascimentali come Donatello e
                        Michelangelo, che ha barattato il suo dipinto per casi. Attraverso un elenco di contatti complicati, il
                        il vino fu introdotto anche alla corte papale di Roma e al re Enrico VIII, annotazioni di
                        che sono in mostra presso la tenuta. Altre tenute includono Castello di Pomino, Tenuta di
                        Castelgiocondo, Tenuta di Castiglioni e Tenuta dell'Ammiraglia. Alla sua 30a generazione, oggi
                        le tenute sono gestite dall'effervescente e carismatico Marchese Lamberto Frescolbaldi, che è
                        impegnati a produrre vini che "solleticano l'anima", ma rimangono consapevoli della diversità di ogni tenuta.
                        Tutte e sei le tenute sono sostenibili.
                    </div>

                    <div class="howto-title2">Il progetto Gorgona</div>
                    <div class="howto-text">
                        Il progetto Gorgona vede i detenuti negli ultimi anni di condanna nel carcere dell'isola di Gorgona
                        lavorare a stretto contatto con gli agronomi ed enologi Frescobaldi. La piccola vigna che fu
                        originariamente piantato con uve Vermentino e Ansonica nel 2012 ora misura 2 ettari ed è
                        commercializzato con il nome omonimo. Il progetto offre ai detenuti competenze tangibili che possono
                        essere utilizzato al loro rilascio e qualcosa anche in banca, poiché Frescobaldi paga loro l'andata
                        tariffa per il proprio lavoro. Prodotto in piccole quantità è possibile acquistarlo sul mercato secondario
                        ma le bottiglie sono molto, molto scarse. Da un'idea della Penitenzieria italiana, quando
                        Frescobaldi chiesto perché fossero stati identificati le autorità hanno risposto: “eravate gli unici
                        rispondere".
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Frescobaldi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Man kann nicht anders, als sich in die Toskana zu verlieben. Schont die Augen; Denken Sie an große, sanfte Hügel und
                        Dörfer mit Terrakottadächern, die den Haushalt schonen; Denken Sie an knackige, schöne Weine und herzhafte,
                        hausgemachte Suppen. Jahrelange Geschichte hat die Form der Landschaft zu dem geformt, was sie heute ist, und der Winzer Frescobaldi ist einer der Künstler, denen wir dafür danken können.
                    </div>

                    <div class="howto-title2">Sieben Jahrhunderte alt</div>
                    <div class="howto-text">
                        Die Frescolbaldi-Anwesen sind die ältesten Anwesen (oder besser gesagt, es gibt sechs davon) in der Toskana
                        Überall in der Region. Ihr ältestes, Castello di Nipozzano im Herzen des Chianti Rufina,
                        stammt aus 700 Jahren und wurde einst Renaissance-Künstlern wie Donatello und serviert
                        Michelangelo, der sein Gemälde gegen Etuis eintauschte. Durch eine Liste komplizierter Kontakte, die
                        Wein wurde auch am päpstlichen Hof in Rom sowie an König Heinrich VIII. eingeführt, wie aus Aufzeichnungen hervorgeht
                        die im Anwesen ausgestellt sind. Weitere Anwesen sind Castello di Pomino und Tenuta di
                        Castelgiocondo, Tenuta di Castiglioni und Tenuta dell'Ammiraglia. Heute in der 30. Generation
                        Die Anwesen werden von dem temperamentvollen und charismatischen Marchese Lamberto Frescolbaldi geführt
                        Wir haben uns der Herstellung von Weinen verschrieben, die „die Seele kitzeln“, und sind sich gleichzeitig der Vielfalt jedes Weinguts bewusst.
                        Alle sechs Anwesen sind nachhaltig.
                    </div>

                    <div class="howto-title2">Das Gorgona-Projekt</div>
                    <div class="howto-text">
                        Das Gorgona-Projekt sieht Häftlinge in den letzten Jahren ihrer Verurteilung im Gefängnis der Insel Gorgona
                        arbeiten eng mit den Agronomen und Önologen von Frescobaldi zusammen. Der kleine Weinberg, der war
                        ursprünglich mit Vermentino- und Ansonica-Trauben im Jahr 2012 bepflanzt, misst jetzt 2 Hektar und ist
                        unter dem gleichnamigen Namen kommerzialisiert. Das Projekt vermittelt den Insassen greifbare Fähigkeiten, die sie können
                        bei ihrer Freilassung verwendet werden und auch etwas auf der Bank, da Frescobaldi ihnen das Geld bezahlt
                        Preis für ihre Arbeit. In kleinen Mengen produziert, kann man es auf dem Sekundärmarkt kaufen
                        Aber Flaschen sind sehr, sehr knapp. Eine Idee der italienischen Strafvollzugsbehörde
                        Frescobaldi fragte, warum sie identifiziert worden seien. Die Behörden antworteten: „Sie waren die Einzigen.“
                        Antworten".
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Frescobaldi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        On ne peut s'empêcher de tomber amoureux de la Toscane. Facile sur les yeux; voyez grand, des collines vallonnées et
                        des villages aux toits de terre cuite, et faciles sur la palette ; pensez beaux vins croquants et copieux,
                        soupes maison. Des années d'histoire ont sculpté la forme du paysage dans ce qu'il est aujourd'hui et le vigneron Frescobaldi est l'un des artistes que nous pouvons remercier pour cela.
                    </div>

                    <div class="howto-title2">Vieux de sept siècles</div>
                    <div class="howto-text">
                        Le plus ancien domaine (ou plutôt domaines, car ils en ont six) en Toscane, les propriétés Frescolbaldi sont
                        partout dans la région. Leur premier, Castello di Nipozzano au cœur du Chianti Rufina,
                        remonte à 700 ans et était autrefois servie à des artistes de la Renaissance tels que Donatello et
                        Michelangelo, qui a troqué sa peinture contre des étuis. Grâce à une liste de contacts compliqués, le
                        le vin a également été introduit à la cour papale à Rome ainsi qu'au roi Henri VIII, les archives de
                        qui sont exposés au domaine. D'autres domaines comprennent Castello di Pomino, Tenuta di
                        Castelgiocondo, Tenuta di Castiglioni et Tenuta dell'Ammiraglia. Dans sa 30e génération, aujourd'hui
                        les domaines sont dirigés par l'effervescent et charismatique marquis Lamberto Frescolbaldi, qui
                        s'engage à faire des vins qui "chatouillent l'âme", tout en restant attentif à la diversité de chaque domaine.
                        Les six domaines sont durables.
                    </div>

                    <div class="howto-title2">Le projet Gorgona</div>
                    <div class="howto-text">
                        Le projet Gorgona voit des détenus dans leurs dernières années de condamnation à la prison de l'île de Gorgona
                        travailler en étroite collaboration avec les agronomes et œnologues Frescobaldi. Le petit vignoble qui était
                        planté à l'origine avec des raisins Vermentino et Ansonica en 2012 mesure maintenant 2 hectares et est
                        commercialisé sous le nom éponyme. Le projet donne aux détenus des compétences concrètes qui peuvent
                        être utilisé à leur libération et quelque chose à la banque aussi, car Frescobaldi leur paie le départ
                        taux pour leur travail. Produit en petites quantités, il est possible d'acheter sur le marché secondaire
                        mais les bouteilles sont très, très rares. Une idée originale du département pénitentiaire italien, quand
                        Frescobaldi a demandé pourquoi ils avaient été identifiés, les autorités ont répondu : « vous étiez les seuls
                        répondre".
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Frescobaldi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One cannot help but fall in love with Tuscany. Easy on the eyes; think big, rolling hills and
                        terracotta-roofed villages, and easy on the pallet; think crisp beautiful wines and hearty,
                        homemade soups. Years of history have sculpted the shape of the landscape into what it is todayand winemaker Frescobaldi is one of the artists we can thank for that.
                    </div>

                    <div class="howto-title2">Seven centuries old</div>
                    <div class="howto-text">
                        The oldest estate (or rather estates, as they have six) in Tuscany, Frescolbaldi properties are
                        everywhere in the region. Their earliest, Castello di Nipozzano in the heart of Chianti Rufina,
                        dates back 700 years and was once served to Renaissance artists such as Donatello and
                        Michelangelo, who traded thier painting for cases. Through a list of complicated contacts, the
                        wine was also introduced to the Papal court in Rome as well as to King Henry VIIIth, records of
                        which are on show at the estate. Other estates include Castello di Pomino, Tenuta di
                        Castelgiocondo, Tenuta di Castiglioni and Tenuta dell'Ammiraglia. In its 30th generation, today
                        the estates are run by the effervescent and charismatic Marchese Lamberto Frescolbaldi, who is
                        committed to making wines that “tickle the soul”, yet remain mindful of each estate's diversity.
                        All six estates are sustainable.
                    </div>

                    <div class="howto-title2">The Gorgona project</div>
                    <div class="howto-text">
                        The Gorgona project sees inmates in their final years of sentencing at Gorgona island prison
                        work closely with Frescobaldi agronomists and oenologists. The small vineyard that was
                        originally planted with Vermentino and Ansonica grapes in 2012 now measures 2-hectares and is
                        commercialised under the eponymous name. The project gives the inmates tangible skills that can
                        be used upon thier release and something in the bank too, as Frescobaldi pays them the going
                        rate for their work. Produced in tiny quantities it is possible to buy on the secondary market
                        but bottles are very, very scarce. A brainchild of the Italian Penitentiary department, when
                        Frescobaldi asked why they had been identified the authorities replied: “you were the only ones
                        to reply”.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Frescobaldi",
    head: {
        title: 'Frescobaldi | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich tradition and exceptional quality of Frescobaldi wines, a renowned Tuscan wine producer. From Chianti Classico to Nipozzano, experience the rich flavor and aroma of each vintage, hand-crafted with passion and expertise.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
